// extracted by mini-css-extract-plugin
module.exports = {"imgWrapper":"FrontpageBanner_imgWrapper__WswYB","img":"FrontpageBanner_img__tsfz1"};